import { AppProps } from 'presentation/App';
import { PageTitle } from 'presentation/components/PageTitle';
import FormRegistInfomantion from './components/FormRegistInfomantion';

const CU00401Page = (props: AppProps) => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
        >
            <PageTitle title="基本情報の登録" />
            <section
                style={{
                    padding: '0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    overflowX: 'hidden',
                }}
            >
                <FormRegistInfomantion {...props} />
            </section>
        </div>
    );
};
export default CU00401Page;
